"use client";

export default function ContactMapSection() {
  return (
    <section className="w-full bg-[#081e2d] py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2
            className="text-white mb-4"
            style={{
            //   fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(2rem, 5vw, 3rem)",
              fontWeight: 700,
            }}
          >
            Find Us on Map
          </h2>

          <p
            className="text-gray-300 max-w-2xl mx-auto"
            style={{
            //   fontFamily: "'Source Sans Pro', sans-serif",
              fontSize: "clamp(1rem, 2vw, 1.125rem)",
              lineHeight: 1.6,
            }}
          >
            Visit our office or explore nearby locations using the map below
          </p>
        </div>

        {/* Map Container */}
        <div className="relative w-full overflow-hidden rounded-xl border border-[#e2ecf4] bg-white">
          <div className="relative w-full h-[300px] sm:h-[400px] md:h-[480px]">
            <iframe
              src="https://www.google.com/maps/d/embed?mid=1oCMp_BMr47_H2Z1fKHMRJ9Dj16UFp24&ehbc=2E312F"
              className="absolute inset-0 w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Company Location Map"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
